// src/pages/Donate.js
import React from 'react';
import './Donate.css';

// You'll import your actual images here once you have them.
// Example:
import imageOne from '../assets/girlslearningandthriving.jpeg';
import imageTwo from '../assets/communityandvocationaltraining.jpg';
import imageThree from '../assets/supportinacaringnvironment.jpg';

// Placeholder for QR code if you use one (can be removed if not)
// import qrCodeImage from '../assets/your_qr_code.png'; // REPLACE with your actual QR code image path if you use QR codes. If not, you can remove this import.

function Donate() {
  return (
    <div className="donate-page">
      <div className="container">

        {/* --- Why Donate Section --- */}
        <section className="why-donate-intro-section">
          <h1 className="donate-heading">Why Donate to Vishwambhara Shikshan Sanstha?</h1>
          <p className="donate-intro-paragraph">
            At Vishwambhara Shikshan Sanstha (VVS), we believe every girl deserves the chance to live with dignity, purpose, and independence—regardless of her intellectual challenges. Since 2006, we’ve been transforming lives through our <b>Smt. Lilatai Deshmukh Residential Special School</b>, providing specialized education, training, and rehabilitation to 65 mentally challenged girls, as sanctioned by the Maharashtra Government.
          </p>
          <p>
            In 2010, we extended our mission by launching the <b>Indutai Dhoble Workshop & Rehabilitation Centre</b>—a vocational training hub where adult girls learn skills like stitching, crafts, packaging, and file-making. More than just trades, we nurture confidence, self-worth, and community.
          </p>
          <p className="highlight-text">
            Your donation directly supports their journey to independence and inclusion. Help us continue creating a space where they’re not only cared for—but empowered to thrive.
          </p>
          <p className="call-to-action-end">
            Donate today. Empower a life.
          </p>
          <div className="center-button-wrapper">
            {/* Changed from <button> to <a> tag with href to the section ID */}
            <a href="#support-section" className="donate-button primary-cta-button">Donate Now</a>
          </div>
        </section>

        {/* --- Image 1 (Example Placement) --- */}
        <div className="section-image-wrapper">
          <img
            src={imageOne} // Replace with your image path
            alt="Girls learning and thriving"
            className="section-image"
          />
        </div>

        {/* --- Mission & Vision Section --- */}
        <section className="mission-vision-section">
          <div className="mission-box">
            <h2 className="section-title">Our Mission</h2>
            <p>
              To empower intellectually disabled girls by providing tailored educational resources, supportive programs, and a nurturing community that fosters confidence, independence, and self-advocacy. We are dedicated to creating opportunities that promote personal growth and social inclusion, enabling every girl to reach her full potential.
            </p>
          </div>
          <div className="vision-box">
            <h2 className="section-title">Our Vision</h2>
            <p>
              A world where intellectually disabled girls are recognized, valued, and empowered to live fulfilling lives. We envision a society where all girls have equal access to opportunities, support, and respect, enabling them to thrive as confident individuals and active participants in their communities.
            </p>
          </div>
        </section>

        {/* --- Image 2 (Example Placement) --- */}
        <div className="section-image-wrapper image-alt-style">
          <img
            src={imageThree} // Replace with your image path
            alt="Support in a caring environment"
            className="section-image"
          />
        </div>

        {/* --- Why Important / Impact Section --- */}
        <section className="impact-section">
          <h2 className="section-title">Why Donations to Special Schools are Crucial</h2>
          <p>
            Donations to special schools for mentally challenged girls are crucial because they provide access to specialized education, therapies, and care, empowering these girls to reach their full potential and live fulfilling lives.
          </p>
          <p>Here’s a breakdown of why these donations are so important:</p>
          <ul>
            <li><strong>Specialized Education and Care:</strong> These schools offer tailored educational programs, therapies (speech, occupational, physical), and support services that address the unique needs of mentally challenged girls.</li>
            <li><strong>Empowerment and Inclusion:</strong> Donations help create inclusive environments where these girls can learn, grow, and develop social skills, fostering a sense of belonging and self-worth.</li>
            <li><strong>Improved Quality of Life:</strong> By providing access to resources and support, these schools help improve the quality of life for mentally challenged girls, enabling them to live more independently and participate more fully in society.</li>
            <li><strong>Breaking the Cycle of Marginalization:</strong> Mentally challenged girls are often marginalized and overlooked, but through education and support, these schools help break the cycle of disadvantage and empower them to achieve their goals.</li>
            <li><strong>Investing in the Future:</strong> Donating to these schools is an investment in the future, as it helps create a more inclusive and equitable society where everyone has the opportunity to thrive.</li>
          </ul>
        </section>

        {/* --- Image 3 (Example Placement) --- */}
        <div className="section-image-wrapper">
          <img
            src={imageTwo} // Replace with your image path
            alt="Community and vocational training"
            className="section-image"
          />
        </div>

        {/* --- Donation Methods Section (Target for the Donate Now button) --- */}
        <section className="donation-methods-section" id="support-section"> {/* Added id="support-section" here */}
          <h2 className="section-title">Support Us: Vishwambhara Shikshan Sanstha, Nagpur.</h2>

          <div className="method-card-wrapper">
            {/* Account Details Card */}
            <div className="method-card bank-details-card">
              <h3>Account Details</h3>
              <p><strong>Account Name:</strong> Vishwambhara Shikshan Sanstha</p>
              <p><strong>Account No:</strong> 1101/10212</p>
              <p><strong>Bank Name:</strong> Shikshak Sahakari Bank Ltd.</p>
              <p><strong>Branch:</strong> Kamal Branch, Nagpur.</p>
            </div>

            {/* WhatsApp Contact Card */}
            <div className="method-card whatsapp-card">
              <h3>Connect via WhatsApp</h3>
              <p>Got questions or want to share transaction details?</p>
              <a href="https://wa.me/918888851101" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                WhatsApp Us
              </a>
              <p className="whatsapp-number">8888851101</p>
            </div>
          </div>
        </section>

        {/* --- Why Donate Items Section --- */}
        <section className="why-donate-items-section">
          <h2 className="section-title">Why Donate items with VSS?</h2>
          <div className="items-benefits">
            <ul>
              <li>Support mentally retired workshop Girls & Woman</li>
              <li>Shelter mentally related girl & woman</li>
              <li>Security & safety</li>
              <li>Health & cleanliness</li>
              <li>Education & empowerment</li>
            </ul>
          </div>

          <h2 className="section-title what-to-donate-heading">What to Donate?</h2>
          <p className="what-to-donate-intro">VSS accepts gently used items including:</p>
          <div className="items-list">
            <ul>
              <li>Foods</li>
              <li>Clothes</li>
              <li>Books</li>
              <li>Toys</li>
              <li>Furniture</li>
              <li>Blankets</li>
              <li>Dry Rations</li>
            </ul>
          </div>
          <p className="items-note">
            While it is important to ensure that the items you are donating are fit to use for someone in need.
          </p>
        </section>

      </div> {/* End .container */}
    </div>
  );
}

export default Donate;